import BoldImg from "../../assests/mobileHIW.svg";
import { motion } from "framer-motion";
import useStyles from "./styles";
import { useRef, useEffect } from "react";
import { Grid } from "@mui/material";
import Navbar from "../../component/Navbar/NavBar";
import Footer from "../../Footer/Footer";

const WhySection = () => {
  const classes = useStyles();
  const FooterRef = useRef(null);
  const FAQRef = useRef(null);
  const HowitworksRef = useRef(null);
  const AboutRef = useRef(null);
  const items = [
    {
      title: "No More Waiting",
      description:
        "Easily set up a group to pool funds and achieve shared financial goals.",
    },
    {
      title: "Pause, Advance, or Switch",
      description:
        "Adjust your payments, skip months, or pay up later we know life happens.",
    },
    {
      title: "Join Anytime",
      description:
        "Jump in at any time and still benefit no rigid group start rules.",
    },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Navbar
        FooterRef={FooterRef}
        HowitworksRef={HowitworksRef}
        AboutRef={AboutRef}
        FAQRef={FAQRef}
      />
      <div className={classes.root}>
        <div className={classes.margincont}>
          <div className={classes.container}>
            <div className={classes.mainpage}>
              <h2>How it works?</h2>
              <p>
                Unlike anything before it, SLOT Finance gives you the freedom to
                contribute on your own terms while keeping the traditional
                group-saving spirit alive.
              </p>
              {/* <img
                src={BoldImg}
                alt="Bold Visual"
                className={classes.boldImage}
              /> */}
              <motion.img
                src={BoldImg}
                alt="Bold Visual"
                className={classes.boldImage}
                animate={{
                  y: [0, -15, 0],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />
            </div>
            <div className={classes.blurbcg}></div>
            <div className={classes.itemWrapper}>
              <Grid
                container
                spacing={{ xs: 0, sm: 2 }}
                sx={{
                  maxWidth: "1420px",
                  margin: "0 auto",
                  paddingInline: "58px",
                  justifyContent: "center",
                  "@media (max-width:500px)": {
                    paddingInline: "1rem"
                  }
                }}
              >
                {items.map((item) => (
                  <Grid item key={item.id} xs={12} sm={12} md={4}>
                    <motion.div
                      className={classes.card}
                      whileHover={{
                        y: -10,
                        scale: 1.03,
                        transition: { duration: 0.3, ease: "easeInOut" },
                      }}
                    >
                      <h4>{item.title}</h4>
                      <p>{item.description}</p>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </div>
          </div>
        </div>
      </div>
      <div ref={FooterRef}>
        <Footer />
      </div>
    </>
  );
};

export default WhySection;
